import React from 'react';
import PropTypes from 'prop-types';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import './FullPageSpinner.css';
var spinnerClasses = getBEMClasses('full-page-spinner');
var FullPageSpinner = function FullPageSpinner(props, context) {
  if (props.pastDelay) {
    return React.createElement(React.Fragment, null, props.isVisible && React.createElement('div', {
      className: spinnerClasses('overlay')
    }, React.createElement('div', {
      className: spinnerClasses('container')
    }, React.createElement('div', {
      className: spinnerClasses('spinner')
    }), React.createElement('div', {
      className: spinnerClasses('text')
    }, context.t('Loading ...')))));
  } else {
    return null;
  }
};
FullPageSpinner.propTypes = {
  isVisible: PropTypes.bool.isRequired
};
FullPageSpinner.defaultProps = {
  isVisible: true
};
FullPageSpinner.contextTypes = {
  t: PropTypes.func.isRequired
};
export default FullPageSpinner;